<template>
  <div class="contact-item-outer">
    <img :src="contact.iconUrl" class="contact-item-icon"/>
    <div class="contact-item-title">{{contact.title}}</div>
    <div class="contact-item-content">{{contact.content}}</div>
  </div>
</template>

<script>
  export default {
    name: 'ContactItem',
    props: {
      contact: Object
    }
  }
</script>

<style scoped>
  .contact-item-outer {
    width: 25%;
    display: inline-block;
    text-align: center;
    transition: all .3s;
  }

  .contact-item-outer:hover {
    transform: scale(1.2);
  }

  .contact-item-icon {
    width: 8.854vw;
    height: 8.854vw;
  }

  .contact-item-title {
    font-family: PingFangSC-Medium;
    font-size: 1.875vw;
    color: #000000;
    text-align: center;
    margin-top: 1.5625vw;
  }

  .contact-item-content {
    font-family: PingFangSC-Medium;
    font-size: 1.875vw;
    color: #000000;
    text-align: center;
    margin-top: 0.99vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactItem.vue